import { aiInRecruitingImpactSectionData } from 'constants/AiInRecruiting'
import styles from './AiInRecruitingImpactSection.module.css'

const CheckIcon = () => (
  <svg
    className={styles.checkIcon}
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5001 1.69434C20.0228 1.69434 25.3126 6.98415 25.3126 13.5069C25.3126 20.0297 20.0228 25.3195 13.5001 25.3195C6.97732 25.3195 1.6875 20.0297 1.6875 13.5069C1.6875 6.98415 6.97732 1.69434 13.5001 1.69434ZM11.047 17.3437L8.15504 14.4493C7.66234 13.9563 7.66224 13.1524 8.15504 12.6595C8.64794 12.1667 9.45544 12.1698 9.94476 12.6595L11.9836 14.7L17.0556 9.62799C17.5485 9.13509 18.3525 9.13509 18.8453 9.62799C19.3382 10.1208 19.3375 10.9255 18.8453 11.4177L12.877 17.386C12.3848 17.8782 11.5801 17.8789 11.0873 17.386C11.0735 17.3721 11.0601 17.3581 11.047 17.3437Z"
      fill="#ffffff"
    />
  </svg>
)

const AiInRecruitingImpactSection = () => {
  const { title, subtitle, items } = aiInRecruitingImpactSectionData

  return (
    <section className={styles.impactSection}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-lg-5">
            <h2 className={styles.sectionTitle}>{title}</h2>
            <p className={styles.sectionSubtitle}>{subtitle}</p>
          </div>
          <div className="col-12 col-lg-7">
            <ul className={styles.list}>
              {items.map((item, i) => (
                <li key={i} className={styles.listItem}>
                  <CheckIcon />
                  <span className={styles.itemText}>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AiInRecruitingImpactSection
